import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'account-mobile',
  templateUrl: '../sharedTemplates/account-mobile.html',
})
export class AccountMobile {
  customer: any;
  // tabSelected:number=0

  constructor(public _UiHelper: UiHelper, public _UserHelper: UserHelper) {
    // this.tabSelected=this.selectMenu;
  }

  closeAccountMobile() {
    this._UiHelper.b3000SetAcountMobileState('close');
  }

  changeSelectMenu(selectMenu: number) {
    this._UiHelper.accountMobileMenu = selectMenu;
  }
}
